import { useContext, useState } from 'react'
import { useLocation } from 'wouter'
import { TextInput } from '@/components/TextInput/TextInput'
import { Button } from '@/components/Button/Button'
import {
  Page,
  Container,
  LogoContainer,
  ContentContainer,
  Title,
  Paragraph,
  Form,
  Label,
  Link,
  ButtonsContainer,
} from '@/styles/page.styles'

import { StoreContext } from '@/components/App'
import { observer } from 'mobx-react'
import axios from 'axios'
import { API_URL } from '@/constants/envs'

export const ChangePasswordPage = observer(() => {
  const [location, navigate] = useLocation()
  const store = useContext(StoreContext)
  const { theme, provider, providerUrl } = store.AppState

  const [password, setPassword] = useState('')
  const [passwordValid, setPasswordValid] = useState(false)
  const [passwordMatch, setPasswordMatch] = useState(false)

  const checkPasswordValidHandler = (e) => {
    const password = e.target.value
    setPassword(password)

    if (password.length > 7 && password.match(/[A-Z]+/) && password.match(/[0-9]+/) && password.match(/[$@#&!]+/)) {
      setPasswordValid(true)
    } else {
      setPasswordValid(false)
    }
  }

  const confirmPasswordHandler = (e) => {
    const confirmPassword = e.target.value

    if (password === confirmPassword) {
      setPasswordMatch(true)
    } else {
      setPasswordMatch(false)
    }
  }

  const handleSetPassword = async () => {
    try {
      const res = await axios.post(
        `${API_URL}/${providerUrl}/set-password`,
        {
          newPassword: password,
        },
        {
          withCredentials: true,
        },
      )

      if (res.status === 200) {
        navigate(`/${provider}/success`)
      } else {
        navigate(`/${provider}/error`)
      }
    } catch (e) {
      console.log(e)
      navigate(`/${provider}/error`)
    }
  }

  return (
    <Page {...theme.app}>
      <Container {...theme.container}>
        {theme.resetPasswordPage.$showAboveTitle && (
          <LogoContainer>
            {theme.logo.$svg && (
              <div>
                <img src={theme.logo.$svg} />
              </div>
            )}
            <div className="empty" />
          </LogoContainer>
        )}

        <ContentContainer {...theme.container}>
          <Title {...theme.title}>Change your password</Title>
          <Paragraph {...theme.paragraph}>
            Password must contain at least 8 characters, upper case letter, digit and symbol (like #!?/’*+)
          </Paragraph>
          <Form>
            <Label {...theme.label}>New password</Label>
            <TextInput
              type="password"
              onChange={checkPasswordValidHandler}
              error={password && !passwordValid}
              errorMessage="Invalid password"
            ></TextInput>

            <Label {...theme.label}>Confirm password</Label>
            <TextInput
              type="password"
              onChange={confirmPasswordHandler}
              error={password && passwordValid && !passwordMatch}
              errorMessage="Passwords don't match"
            ></TextInput>
          </Form>
          <ButtonsContainer {...theme.buttonsContainer}>
            <Button {...theme.button} isDisabled={!passwordMatch} onClick={handleSetPassword}>
              Continue
            </Button>
          </ButtonsContainer>
        </ContentContainer>
      </Container>
    </Page>
  )
})
